export default {
  //获取角色
  Roles({commit}, newrouter) {
    return new Promise((resolve, reject) => {
      commit('SET_NEWROUER', newrouter); //存储最新路由
      resolve(newrouter);
    }).catch(error => {
      reject(error);
    });
  },
  //登出
  Logout({commit, state}) {
    return new Promise((resolve, reject) => {
      location.reload();
      setTimeout(()=>{
        commit('SET_TOKEN', '');
        commit('SET_ROLE', '');
        commit('SET_NEWROUER', []);
      },500);
      resolve();
    }).catch(error => {
      reject(error);
    });
  },
};



// WEBPACK FOOTER //
// ./src/store/actions.js